// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".user-layout .grid{transition:.5s}.user-layout .sidebar-closed.logged-in{display:grid;grid-template-columns:3fr;grid-gap:0;gap:0}.not-logged-in.user-info-sidebar-wrapper .user-info-sidebar{left:8px}@media (max-width:992px){.user-layout .sidebar-closed,.user-layout .sidebar-closed.logged-in{display:block}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
